import React from "react";

import { states } from "./data-local/estados-hashtable.json";
import {
  formataData,
  formatarDadosDaApresentacao,
  retornaNomeDoEstadoPelaUF,
} from "../../../../utils/functions/PainelPage/format";

import FilterComponent from "./FilterComponent";
import {
  PresentationContainer,
  PresentationContent,
  PresentationDescription,
  PresentationHeader,
  PresentationHeadling,
  ProgressCiculeLoading,
  LoadingContainer,
  Observasao,
} from "./styles";
import { useAxios } from "../../../../hooks/useAxios";

export function Apresentacao({ queryState, setState }) {
  const [data, setData] = React.useState(null);

  let uri = `/informacoes_gerais/?uf=${queryState}`;
  const { loading, error, response } = useAxios({
    method: "GET",
    url: uri,
    headers: {
      accept: "*/*",
    },
  });

  React.useEffect(() => {
    if (response) {
      setData(formatarDadosDaApresentacao(response));
    }
    //formatarDadosDaApresentacao(data_local);
  }, [response]);

  return (
    <>
      <PresentationContainer>
        <PresentationContent>
          <PresentationHeadling>
            <PresentationHeader>
              Casos de covid-19 em profissionais da saúde
            </PresentationHeader>
            <FilterComponent
              options={states}
              title={"Estado"}
              onChange={setState}
              value={queryState}
              placeholder={"Selecione um estado"}
            />
          </PresentationHeadling>
        </PresentationContent>
      </PresentationContainer>
      <PresentationContainer light>
        {loading ? (
          <PresentationContent>
            <LoadingContainer>
              <PresentationDescription>
                Carregando dados...
                <ProgressCiculeLoading size={20} color={"inherit"} />
              </PresentationDescription>
            </LoadingContainer>
          </PresentationContent>
        ) : (
          <>
            {data && (
              <PresentationContent>
                <PresentationDescription
                  dangerouslySetInnerHTML={{
                    __html: `Até <strong>${formataData(
                      data.dados.data_mais_recente
                    )}</strong> no <strong>${retornaNomeDoEstadoPelaUF(
                      queryState
                    )}</strong>, 
                foram notificados <strong>${data.dados.total_casos_profissionais_saude
                      }</strong> casos de covid-19 em 
                profissionais da saúde, que representa <strong>${data.dados.porcent_total_casos_profissionais_saude
                      }%</strong>
                do total de casos confirmados. Também foram notificados <strong>${data.dados.total_internacoes_profissionais_saude
                      }</strong>
                internações e <strong>${data.dados.total_obitos_profissionais_saude
                      }</strong> óbitos entre profissionais de saúde, que 
                representa <strong>${data.dados.porcent_total_internacoes_profissionais_saude
                      }%</strong> do total de internações e <strong>${data.dados.porcent_total_obitos_profissionais_saude
                      }%</strong> do total de 
                óbitos, respectivamente.`,
                  }}
                />
                <Observasao>* Observação: este painel usa como fonte bases de dados públicas de Síndrome Gripal (SG)
                  e Síndrome Respiratória Aguda Grave (SRAG) do DataSUS, que podem conter erros nos registros. Os
                  campos referentes à identificação de profissionais de saúde nem sempre são preenchidos, gerando
                  subnotificação.
                </Observasao>
              </PresentationContent>
            )}



            {error && <></>}
          </>
        )}
      </PresentationContainer>
    </>
  );
}
